import { gridClasses } from '@mui/x-data-grid-pro';

export const gridStyles = {
  [`& .${gridClasses.cell}`]: {
    display: 'flex',
    alignItems: 'center',
  },
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]: {
    outline: 'none',
  },
};

// Reusable styles to disable row hover background
export const noRowHoverStyles = {
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'transparent',
  },
  // Pinned columns need specific override (they have their own background)
  '& .MuiDataGrid-virtualScrollerContent .MuiDataGrid-row:hover .MuiDataGrid-cell--pinnedLeft': {
    backgroundColor: 'transparent',
  },
  '& .MuiDataGrid-virtualScrollerContent .MuiDataGrid-row:hover .MuiDataGrid-cell--pinnedRight': {
    backgroundColor: 'transparent',
  },
};
